import { typedHttpsCallableWrapper } from '../api-_utils';
import { API_ROUTE_CONFIG } from './api-config/config';

export abstract class APIClinic {
  public static getLatestPrincipalUser = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.principalUser.getLatestPrincipalUser);
  public static submitPrincipalUser = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.principalUser.submitPrincipalUserConfig);
  public static setPrincipalUser = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.principalUser.setPrincipalUser);
  public static changeRole = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.role.changeRole)
  public static removePatient = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.remove.patient);
  public static removeClinicAdmin = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.remove.clinicadmin);
  public static removeClinician = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.remove.clinician);
  public static removePatientInvite = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.remove.patientInvite);
  public static removeClinicianInvite = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.remove.clinicianInvite);
  public static joinGlobalAdmin = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.globaladmin.join);
  public static leaveGlobalAdmin = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.globaladmin.leave);
}

export abstract class APIClinicBalance {
  public static getBalance = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.balance.getBalance
  );
  public static setProductSupportsOnDemandPurchases = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.balance.setProductSupportsOnDemandPurchases
  );

  public static viewAggregatedUsageHistory = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.balance.viewAggregatedUsageHistory
  );
}

export abstract class APIClinicBilling {
  public static getStripeCheckoutPage = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.billing.getStripeCheckoutPage
  );

  public static buyBulkAssessment = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.billing.buyBulkAssessments
  );
  public static buyOnDemandAssessment = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.billing.buyOnDemandAssessment
  );

  public static getProductPrice = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.billing.getProductPrice
  );

  public static hasPaymentMethod = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.billing.hasPaymentMethod
  );

  public static hasSubscription = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.billing.hasSubscription
  )

  public static getInvoice = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.billing.getInvoice
  );

  public static getCustomerSession = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.billing.getCustomerSession)

  public static createCheckoutSession = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.billing.createCheckoutSession
  );

  public static getAllProducts = typedHttpsCallableWrapper(API_ROUTE_CONFIG.clinic.billing.getMatchedProducts);
}
